<template>
  <v-tooltip top transition="fade-transition">
    <template v-slot:activator="{ on }">
      <v-btn icon small @click="onDownload" target="_blank" v-on="on" v-if="hasUrl">
        <v-icon small>{{ $vuetify.icons.values.download }}</v-icon>
      </v-btn>
      <v-btn v-else icon small v-on="on">
        <v-icon small>{{ $vuetify.icons.values.error }}</v-icon>
      </v-btn>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'DownloadBtn',
  props: { file: { type: Object, required: true } },
  computed: {
    hasUrl() {
      return !!this.file.uris.download
    },
    tooltipText() {
      return this.hasUrl ? this.$t('labels.download') : this.$t('labels.fileError')
    }
  },
  methods: {
    onDownload() {
      fetch(this.file.uris.download, {})
        .then((response) => response.blob())
        .then((blob) => {
          const blobURL = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobURL
          a.style = 'display: none'
          a.download = this.file.filename
          document.body.appendChild(a)
          a.click()
        })
        .catch(() => {})
    }
  }
}
</script>
